import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import "../css/about.scss";
import { Link } from "react-router-dom";
import { FiArrowRight } from "react-icons/fi";
import siteConfig from "../config/siteConfig";

function About() {
  const toTop = () => window.scrollTo({ top: 0, behavior: "smooth" });

  return (
    <div className="about">
      <Header />
      <main className="about__main">
        <section className="about-hero">
          <img src="/main/about-community.jpg" alt="Friends in everyday workwear outside a studio" />
          <div className="about-hero__shade" />
          <div className="about-hero__copy">
            <span className="eyebrow">This is {siteConfig.brandName}</span>
            <h1>Denim with<br />a future.</h1>
          </div>
        </section>

        <section className="about-intro">
          <span className="eyebrow">Our point of view</span>
          <div>
            <h2>Make fewer things.<br />Make them matter.</h2>
            <p>
              {siteConfig.brandName} began with one simple belief: good denim should become more valuable
              with time. We design every seam, rivet, and fabric choice around long use, and publish the care
              information that helps customers keep it going.
            </p>
          </div>
        </section>

        <section className="about-values">
          <article><strong>100%</strong><span>Organic cotton across every cotton style in this collection.</span></article>
          <article><strong>30</strong><span>Days to decide whether a new piece belongs in your wardrobe.</span></article>
          <article><strong>∞</strong><span>Potential lives when repair and reuse come before replacement.</span></article>
        </section>

        <section className="about-repair">
          <figure><img src="/main/about-repair.jpg" alt="A skilled maker repairing the knee of worn jeans" loading="lazy" /><figcaption>Every mark is worth keeping.</figcaption></figure>
          <div>
            <span className="eyebrow">Care before replacement</span>
            <h2>Broken does not mean finished.</h2>
            <p>
              Small damage becomes larger when ignored. Inspect high-friction areas, follow the sewn label,
              and consider an appropriate local alteration professional before a worn area spreads.
            </p>
            <Link to="/product-care">Read the garment care policy <FiArrowRight /></Link>
          </div>
        </section>

        <section className="about-materials">
          <div>
            <span className="eyebrow">Materials</span>
            <h2>Start with better fiber.</h2>
            <p>
              Organic cotton avoids synthetic pesticides and genetically modified seed. It is not a finish line,
              but it is a better place to begin. We pair it with durable constructions and lower-impact washes,
              then publish the material and maker details on each product.
            </p>
          </div>
          <img src="/main/about-materials.jpg" alt="Indigo denim and natural cotton material study" loading="lazy" />
        </section>

        <section className="about-cta">
          <p>Make your own vintage.</p>
          <Link className="app-button app-button--light" to="/shop" onClick={toTop}>Shop denim <FiArrowRight /></Link>
        </section>
      </main>
      <Footer />
    </div>
  );
}

export default About;
